<template>
  <div class="field-box">
    <label class="field-label">{{ title }}</label>
    <div class="field-main">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FieldBox',
  props: {
    title: String
  }
}
</script>

<style lang="less" scoped>
.field-box {
  display: flex;
  margin-bottom: 10px;
}
.field-label {
  flex: 1;
  min-width: 104px;
  height: 32px;
  line-height: 32px;
  padding: 0 0 0 10px;
  text-align: left;
}
.field-main {
  width: 210px;
  padding-right: 10px;
  margin: 0;
}
</style>
